import { graphql } from 'gql.tada';
import { useMutation } from '@apollo/client';

const SetStudentEnrollmentStatusMutation = graphql.persisted(
  "SetStudentEnrollmentStatus",
  graphql(`
    mutation SetStudentEnrollmentStatus($studentEnrollmentId: ID!, $status: StudentEnrollmentStatusEnum!) {
      setStudentEnrollmentStatus(input: {studentEnrollmentId: $studentEnrollmentId, status: $status}) {
        studentEnrollment { id state }
        userErrors { message path }
      }
    }
  `)
);

export { SetStudentEnrollmentStatusMutation };

export function useSetStudentEnrollmentStatus() {
  return useMutation(SetStudentEnrollmentStatusMutation);
}
